import EditPlatformContainer from "@containers/dashboard/platforms/edit";
import { PlatformDefaultValue } from "@containers/dashboard/platforms/edit/settings";
import DashboardLayout from "@layouts/dashboard";
import RoutesInstance from "@routes/instances";
import { useQuery } from "@tanstack/react-query";
import Common from "@utilities/common";
import { useEffect } from "react";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";

const EditPlatform = () => {
    const params = useParams();

    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    const { data, isLoading, refetch } = useQuery(
        ["getPlatform"],
        () =>
            Common.api.platforms
                .GetSingle({
                    id: params.id || "",
                })
                .then((res) => res.data),
        {
            enabled: true,
            retry: false,
            onError: () => {
                Navigate(RoutesInstance.platforms);
            },
            onSuccess: () => {
                URLSearchParams.set("refetch", "");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    useEffect(() => {
        if (URLSearchParams.get("refetch") === "true") {
            refetch();
        }
    }, [URLSearchParams]);

    return (
        <DashboardLayout title="ویرایش پلتفرم">
            <EditPlatformContainer
                data={data?.result || PlatformDefaultValue}
                loading={isLoading}
            />
        </DashboardLayout>
    );
};

export default EditPlatform;
